import * as React from 'react';
import { ApSimpleDropdown } from '@alixpartners/ui-components';
import groupBy from 'lodash/groupBy';
import { TopVendorsTable } from 'components/Tables/TopVendors';
import {
  SectionWrapper,
  HeaderLabel,
  TopDataContent,
  HeaderTop,
} from './Analysis.styles';
import { ApiContext } from 'context/ApiContext';
import { EXPORT_OPTIONS } from 'utils/constants';
import { getDateLabels } from 'utils/format';
import { ICurrencyFormat, ISpend, ITopVendorsResponse } from 'utils/types';

const COLUMNS = ['Opex', 'Capex', 'Total'];

const findItem = (items: ISpend[], type: string): ISpend | undefined => {
  return items.find((el) => el.type === type);
};

const TopVendorsView = ({
  downloadSpendTopVendorsData,
  format,
  showSuccessNotification,
  topVendors,
}: {
  downloadSpendTopVendorsData: () => Promise<any>;
  format: ICurrencyFormat;
  showSuccessNotification: () => void;
  topVendors: ITopVendorsResponse;
}) => {
  if (!topVendors) {
    return null;
  }
  const { spends } = topVendors;
  const groupedSpends = groupBy(spends, 'dimValue');
  const columnDataLabels = getDateLabels(
    topVendors.range,
    topVendors.comparisonRange
  );
  let totalRow;
  const data = Object.keys(groupedSpends)
    .map((title) => {
      const rowItems = groupedSpends[title];
      const row = COLUMNS.reduce(
        (acc, columnTitle, index) => {
          const item = findItem(rowItems, columnTitle);
          acc[`category${index + 1}PrevYear`] = item?.previousValue;
          acc[`category${index + 1}CurrYear`] = item?.currentValue;
          acc[`category${index + 1}Variance`] = item?.change;
          return acc;
        },
        {
          title,
          category1PrevYear: undefined,
          category1CurrYear: undefined,
          category1Variance: undefined,
          category2PrevYear: undefined,
          category2CurrYear: undefined,
          category2Variance: undefined,
          category3PrevYear: undefined,
          category3CurrYear: undefined,
          category3Variance: undefined,
        } as { [x: string]: any }
      );
      if (title.toLowerCase() === 'total') {
        totalRow = row;
        return {};
      }
      return row;
    })
    .filter((row) => Object.keys(row).length !== 0);
  return (
    <SectionWrapper>
      <HeaderTop>
        <HeaderLabel>Top vendors</HeaderLabel>
        <ApSimpleDropdown
          iconName="outline_save_alt"
          onChange={(s: any) => {
            if (s.value === 'xlsx') {
              downloadSpendTopVendorsData().then(showSuccessNotification);
            }
          }}
          options={[EXPORT_OPTIONS[1]]}
          label="Export"
        />
      </HeaderTop>
      <TopDataContent>
        <TopVendorsTable
          columns={COLUMNS}
          columnDateLabels={columnDataLabels}
          format={format}
          rowData={data}
          totalRow={totalRow}
        />
      </TopDataContent>
    </SectionWrapper>
  );
};

export default (props: any) => (
  <ApiContext.Consumer>
    {({ format }) => <TopVendorsView {...props} format={format} />}
  </ApiContext.Consumer>
);
